<template>
  <ed-modal
    :show="show"
    :title="title"
    type="medium"
    @close="onClose"
    @validate="onSave"
    :validation="validation"
    :primaryButtonDisabled="saveButtonDisabled"
    :closeOnEsc="true"
  >
    <div slot="body">
      <section>
        <section>
          <br>

          <div class="row">
            <div class="heading col-md-4 no-pad"><label> Taxes</label></div>
            <div class="pull-left text-center">&nbsp;&nbsp;</div>
            <div class="heading right-label col-md-2"><label> Percent</label></div>
            <div class="pull-left text-center">&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div class="heading right-label col-md-2"><label> Amount</label></div>
          </div>

          <tax-line v-for="(tax, index) in formData.model.taxes"
            :key="tax.name"
            :model="tax"
            :index="index"
            :compute="computeDraftFeeTotal"
            :context="vm"
            class="row"
            ref="taxLine"
          />

          <div class="row">
            <div class="pull-left text-center">&nbsp;&nbsp;</div>
            <div class="col-xs-8 text-right" name="fee_taxes_popup_subtotal">
              <strong>
                <small>
                  Subtotal: &nbsp;
                  <v-money :currency="model.currency.code" :supplementalPrecision="6">{{ formData.model.totalTaxes }}</v-money>
                </small>
              </strong>
            </div>
          </div>
        </section>
      </section>
    </div>
  </ed-modal>
</template>
<script>
/* eslint spec-file: 0 */

import TaxLine from '../../components/taxLine'
import LineItemStore from './LineItemStore.js'

export default {
  name: 'AddFeeTaxes' /* mandatory field */,

  components: {
    TaxLine
  },

  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object
  },

  data() {
    return {
      vm: this,
      store: () => new LineItemStore(this.api),

      formData: {
        model: utils.copy(this.model)
      },
      show: true,
      saveButtonDisabled: false,
      validation: true,
      title: 'Add Taxes on Fee'
    }
  },

  computed: {
    currency() {
      return this.model.currency.code
    }
  },

  methods: {
    onClose() {
      this.eventHub.$emit('onCloseAddFeeTaxes', {})
      this.show = false
    },

    onSave() {
      this.eventHub.$emit('onAddedFeeTaxes', {
        eventData: this.formData.model
      })

      this.show = false
    },

    computeDraftFeeTotal() {
      let fee = this.formData.model

      return this.store().computeFeeTotal(fee, this.model.currency)
        .then(response => {
          fee = this.store().populateTotalsOnFee(fee, response.data.fee)
        })
    },

    getNamePercent(name) {
      return name + '_percent'
    },

    getNameAmount(name) {
      return name + '_amount'
    },

    getTaxId(name) {
      return 'item_fee_tax_' + name
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.heading {
  &.right-label {
    text-align: right;
    padding-right: 27px;
  }
  label {
    font-weight: $font-weight-extra-bold;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/dialogs/LineItem/AddFeeTaxes.vue